/* KOOLLIA article reading tools */
(function () {
  var OFFSET = 96;
  var ACTIVE_CLASS = 'koollia-active';
  var OPEN_CLASS = 'is-open';
  var items = [];
  var allLinks = [];

  function throttle(fn, wait) {
    var timer = null;
    var last = 0;

    return function () {
      var now = Date.now();
      var remaining = wait - (now - last);

      if (remaining <= 0) {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }

        last = now;
        fn();
        return;
      }

      if (!timer) {
        timer = setTimeout(function () {
          last = Date.now();
          timer = null;
          fn();
        }, remaining);
      }
    };
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function slugify(text) {
    var slug = String(text || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return slug || 'section';
  }

  function updateProgress() {
    var bar = document.getElementById('koollia-progress-bar');

    if (!bar) return;

    var doc = document.documentElement;
    var scrollTop = window.pageYOffset || doc.scrollTop || 0;
    var max = Math.max(doc.scrollHeight - doc.clientHeight, 1);
    var progress = Math.min((scrollTop / max) * 100, 100);

    bar.style.width = progress + '%';
  }

  function buildToc() {
    var content = document.getElementById('koollia-content');
    var used = {};

    items = [];

    if (!content) return;

    toArray(content.querySelectorAll('h2, h3')).forEach(function (heading) {
      var text = heading.textContent.replace(/\s+/g, ' ').trim();

      if (!text) return;

      var base = slugify(text);
      var slug = base;
      var count = 2;

      while (used[slug]) {
        slug = base + '-' + count;
        count += 1;
      }

      used[slug] = true;

      if (!heading.id) {
        heading.id = 'koollia-' + slug;
      }

      items.push({
        id: heading.id,
        level: parseInt(heading.tagName.substring(1), 10),
        text: text
      });
    });
  }

  function closeMobileToc() {
    var btn = document.getElementById('koollia-toc-btn');
    var nav = document.getElementById('koollia-toc-mobile-nav');

    if (nav) nav.hidden = true;

    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove(OPEN_CLASS);
    }
  }

  function makeLinks(nav, onClick) {
    if (!nav) return;

    nav.innerHTML = '';

    if (!items.length) {
      nav.innerHTML = '<p class="koollia-toc-empty">No sections yet.</p>';
      return;
    }

    items.forEach(function (item) {
      var link = document.createElement('a');

      link.href = '#' + item.id;
      link.textContent = item.text;
      link.setAttribute('data-level', String(item.level));

      link.addEventListener('click', function (event) {
        var target = document.getElementById(item.id);

        event.preventDefault();

        if (target) {
          var top = target.getBoundingClientRect().top + (window.pageYOffset || 0) - OFFSET;

          window.scrollTo({
            top: Math.max(top, 0),
            behavior: 'smooth'
          });
        }

        if (onClick) onClick();
      });

      nav.appendChild(link);
    });
  }

  function updateActiveLink() {
    if (!items.length || !allLinks.length) return;

    var scrollTop = (window.pageYOffset || 0) + OFFSET + 12;
    var currentId = items[0].id;

    items.forEach(function (item) {
      var heading = document.getElementById(item.id);
      var top;

      if (!heading) return;

      top = heading.getBoundingClientRect().top + (window.pageYOffset || 0);

      if (top <= scrollTop) {
        currentId = item.id;
      }
    });

    allLinks.forEach(function (link) {
      var isActive = (link.getAttribute('href') || '').replace('#', '') === currentId;

      link.classList.toggle(ACTIVE_CLASS, isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function initMobileToc() {
    var btn = document.getElementById('koollia-toc-btn');
    var nav = document.getElementById('koollia-toc-mobile-nav');

    if (!btn || !nav) return;

    btn.addEventListener('click', function () {
      var willOpen = nav.hidden;

      nav.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
      btn.classList.toggle(OPEN_CLASS, willOpen);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMobileToc();
      }
    });
  }

  function init() {
    var desktopNav = document.getElementById('koollia-toc-desktop-nav');
    var mobileNav = document.getElementById('koollia-toc-mobile-nav');

    buildToc();
    makeLinks(desktopNav);
    makeLinks(mobileNav, closeMobileToc);

    allLinks = toArray(document.querySelectorAll('#koollia-toc-desktop-nav a, #koollia-toc-mobile-nav a'));

    initMobileToc();
    updateProgress();
    updateActiveLink();

    window.addEventListener('scroll', throttle(updateProgress, 16), { passive: true });
    window.addEventListener('scroll', throttle(updateActiveLink, 80), { passive: true });
    window.addEventListener('resize', throttle(updateProgress, 120), { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
